
















import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class NavbarWalletStatusIcon extends Vue {
  @Prop({type: Boolean, required: true}) isConnected!: boolean
}
